<div class="login-body">
    <div class="login-box">
        <div class="p-float-label" >
            <input id="username" #usrnam  pInputText [(ngModel)]="userName" autocomplete="new-password">
            <label>UserName</label>
        </div>
        <div class="p-float-label" >
            <input #pass type="password" pInputText [(ngModel)]="password"  autocomplete="new-password" >
            <label>Password</label>
        </div>
        <div >
            <button  (click)="login()"  class="button darkblue">Login</button>
        </div>

    </div>

</div>